import axios from "axios";

// For Production API
export const ApiUrl = "https://cms.kurnooldiocese.org/api";

// For Development API
// export const ApiUrl = "http://127.0.0.1:8000/api";

// In-memory cache and in-flight requests deduplication
const responseCache = new Map();
const pendingRequests = new Map();
const CACHE_TTL_MS = 60000; // 60 seconds TTL

// Preserve original get method
const originalAxiosGet = axios.get;

// Patch axios.get globally to deduplicate in-flight requests and cache GET responses
axios.get = function (url, config = {}) {
  // Option to bypass cache explicitly if requested
  if (config && config.bypassCache) {
    return originalAxiosGet.call(axios, url, config);
  }

  const cacheKey = url + JSON.stringify(config?.params || {});
  const now = Date.now();

  // 1. Return valid cached response if available
  if (responseCache.has(cacheKey)) {
    const cached = responseCache.get(cacheKey);
    if (now - cached.timestamp < CACHE_TTL_MS) {
      return Promise.resolve(cached.response);
    } else {
      responseCache.delete(cacheKey);
    }
  }

  // 2. Deduplicate in-flight request to prevent duplicate concurrent network calls
  if (pendingRequests.has(cacheKey)) {
    return pendingRequests.get(cacheKey);
  }

  // 3. Initiate network request & store pending promise
  const requestPromise = originalAxiosGet.call(axios, url, config)
    .then((response) => {
      responseCache.set(cacheKey, {
        response: response,
        timestamp: Date.now(),
      });
      return response;
    })
    .catch((error) => {
      // Don't cache errors
      throw error;
    })
    .finally(() => {
      pendingRequests.delete(cacheKey);
    });

  pendingRequests.set(cacheKey, requestPromise);
  return requestPromise;
};

export const clearApiCache = () => {
  responseCache.clear();
  pendingRequests.clear();
};
